<template>
  <v-container id="sponsors" fluid>
    <h1 class="primary--text mt-3 mb-4">
      Verlagspartner
    </h1>

    <div>
      <p>Auf unserem Event erwartet Dich nicht nur geballtes Wissen in Form von Vorträgen und Workshops. Wir haben Dir auch eine Bücherwand passend zum unserem diesjährigen Schwerpunkt „Digitale Geschäftspräsenzen und Online Marketing“ zusammengestellt.</p>
      <p>Mehr als 30 Titel, mit noch mehr Know How, wollen von Dir durchgeblättert und studiert werden. Der Clou? Ungeduldige Bücherfans können ihr Lieblingsbuch direkt per QR Code in der Kaffeepause shoppen. Geduldige Leseratten warten ab, ob sie einen der Titel in der Verlosung gewinnen!</p>
      <p>Die Lektüre folgender Verlage wartet darauf, von Dir entdeckt zu werden:</p>
    </div>

    <v-layout row wrap>
      <template v-for="(item, index) in items">
        <v-flex :key="index" xs12 md6>
          <v-card
            color="white"
            class="mt-4"
            :class="{ 'mx-3': $vuetify.breakpoint.mdAndUp }"
          >
            <div class="pt-4 pb-3">
              <v-img
                :src="require('../assets/images/publishers/' + item.image)"
                :height="item.height"
                contain
                class="mx-auto"
              />
            </div>

            <v-card-title>
              <div>
                <h3 class="headline mb-3">{{ item.title }}</h3>
                <div v-html="item.text" />
              </div>
            </v-card-title>

            <v-divider light />
            <v-card-actions v-if="item.link">
              <v-btn flat color="accent" :href="item.link" target="_blank">
                Website
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-flex>
      </template>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  data () {
    return {
      items: [
        {
          title: 'Rheinwerk Verlag',
          text: 'Der Rheinwerk Verlag ist der führende deutsche Fachverlag für digitale Themen. Wir machen Bücher für junge und erfahrene Online-Marketer, für Programmier-Neulinge und Geeks, für Admins und Entwickler, Gamer und YouTuber, kurz: für alle, die sich in der digitalen Welt weiterbilden möchten. Bei uns findet jeder zu seinem Thema das passende Buch, vom Grundlagenkurs bis zum umfassenden Handbuch, gedruckt, digital oder beides im Bundle. Stöbern Sie gern in unserem Webshop und lesen Sie in jedes Buch rein, wir freuen uns auf Sie!',
          image: 'rheinwerk.png',
          link: 'https://www.rheinwerk-verlag.de',
          height: '100'
        },
        {
          title: 'Hermann Schmidt',
          text: 'Der Verlag Hermann Schmidt steht für ein kleines, feines Nischenprogramm, das kreative Köpfe kribbeln und die Herzen von Kreativen höher schlagen lässt. Bücher und Produkte von Schmidt begleiten Gestalter+innen durch den Kreativ-Alltag, sie stiften Nutzen und bringen Freude. Sie vermitteln handwerkliches Know-How, helfen bei (Karriere-) Entscheidungen, ordnen ein, denken weiter, ebnen Wege, und sind Habenwollen-Bücher, die man und frau nur ungern aus der Hand legt.',
          image: 'hermann-schmidt.png',
          link: 'https://typografie.de',
          height: '50'
        },
        {
          title: 'Murmann Verlag',
          text: 'Im Murmann Verlag erscheinen Bücher, die die Zukunft von Wirtschaft und Gesellschaft im Heute erlebbar machen. Unsere Autoren sind Innovatoren, denn sie trauen sich, Karriere und Transformation neu und anders zu denken. Seit der Gründung 2004 publiziert der Hamburger Verlag hochwertige Bücher, die sich schnell zur Pflichtlektüre von Managern, Start-up-Gründern und Machern entwickelt haben. Heute gehört er zu den führenden deutschen inhabergeführten Sachbuchverlagen mit den Schwerpunkten Wirtschaft, Gesellschaft, Karriere und Innovation. Unter den Autoren sind bekannte Querdenker und Visionäre, Experten für digitale Transformation und Neues Arbeiten sowie führende Unternehmens – und Innovationsberater.',
          image: 'murmann.png',
          link: 'https://www.murmann-verlag.de',
          height: '100'
        },
        {
          title: 'Wiley-VCH',
          text: 'Wissenschaftlicher und technischer Fortschritt sind von ausschlaggebender Bedeutung für die Entwicklung unserer Gesellschaft. Wiley-VCH publiziert für die wissenschaftliche Community, wissenschaftliche Gesellschaften sowie für Forscher, Praktiker, Lehrende und Studenten sowie Interessierte. Die Versorgung von Wissenschaft, Technik und Wirtschaft mit qualitativ hochwertigen Informationen im Print- und Onlinebereich wird von uns in den unterschiedlichsten Formen gewährleistet: Zeitschriften, Bücher, Nachschlagewerke, Datenbanken und Dienstleistungen. Unsere Produkte sind so konzipiert, dass sie speziell auf den Informationsbedarf des jeweiligen Leserkreises zugeschnitten sind. Damit sind wir erfolgreich: ständig wächst die Nachfrage nach den angebotenen Inhalten, der veröffentlichten Seiten, der Zugriffe auf unsere Online Plattform Wiley Online Library, den Portalen und Homepages.',
          image: 'wiley.jpg',
          link: 'https://www.wiley-vch.de',
          height: '100'
        },
        {
          title: 'Redline',
          text: 'Redline entstand als Wirtschaftsverlag im Jahr 2002, als die Programme der Verlage moderne industrie und Carl Ueberreuter unter dem Label Redline Wirtschaft zusammengelegt unter dem Dach des Süddeutschen Verlags zusammengelegt wurden. Redline Wirtschaft spezialisierte sich von Anfang an auf Sachbücher und Ratgeber im Bereich Management und Karriere. 2008, nach der Übernahme durch die Münchner Verlagsgruppe mit der damit einhergehenden Umbenennung in redline, erweiterte sich das Verlagsprogramm kontinuierlich. Aktuell veröffentlicht redline zu den Themen Management und Unternehmensführung, Marketing und Verkauf, Beruf und Karriere sowie Wirtschaft und Politik.',
          image: 'redline.png',
          link: 'https://www.m-vg.de/redline/shop/',
          height: '50'
        },
        {
          title: 'FinanzBuch Verlag',
          text: 'Der FinanzBuch Verlag wurde 1997 von Christian Jund gegründet. Anlass der Gründung war der Mangel an aktueller, aber auch grundlegender Anleger-, Börsen- und Finanzliteratur im deutschsprachigen Raum. Der FinanzBuch Verlag bot anfangs vor allem US-amerikanische Titel an, begann jedoch schon bald, auch eigene Originalausgaben zu verlegen. Mittlerweile hat sich das Verlagsspektrum deutlich erweitert und umfasst nicht nur Anlage-Ratgeber, sondern auch Literatur zu bedeutenden Wirtschaftsgrößen und zur Wirtschafts- und Finanzpolitik. Der FinanzBuch Verlag gehört heute zu den wichtigsten und größten Finanz- und Wirtschaftsverlagen Deutschlands.',
          image: 'finanzbuch.png',
          link: 'https://www.m-vg.de/finanzbuchverlag/shop/home/',
          height: '50'
        },
        {
          title: 'mitp-Verlag',
          text: 'Der mitp-Verlag ist einer der führenden IT-Fachbuchverlage aus Deutschland. Wir gehören weder zu einer Verlagsgruppe noch zu einem anderen großen Unternehmen und sind deshalb vollkommen unabhängig. Unseren Lesern bieten wir Profiwissen zu aktuellen Themen vom umfassenden Lehrbuch bis zum kompakten Praxisbuch. Da ist für alle etwas dabei – wir haben Bücher für Einsteiger, Fortgeschrittene und Profis.',
          image: 'mitp.png',
          link: 'https://www.mitp.de/',
          height: '100'
        },
        {
          title: 'Hanser-Verlag',
          image: 'hanser.png',
          link: 'https://www.hanser-fachbuch.de',
          height: '50'
        },
        {
          title: 'dpunkt.verlag',
          image: 'dpunkt.jpg',
          link: 'https://www.dpunkt.de',
          height: '50'
        },
        {
          title: 'O\'Reilly',
          image: 'oreilly.jpg',
          link: 'https://www.oreilly.de',
          height: '75'
        },
        {
          title: 'Haufe',
          image: 'haufe.jpg',
          link: 'https://shop.haufe.de/',
          height: '25'
        }
      ]
    }
  }
}
</script>
